import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Sommerhusrengoering from "./pages/Sommerhusrengoering";
import AirbnbRengoering from "./pages/AirbnbRengoering";
import DoedsboRengoering from "./pages/DoedsboRengoering";
import HusLejlighedRengoering from "./pages/HusLejlighedRengoering";
import HundeklipVask from "./pages/HundeklipVask";
import Kontakt from "./pages/Kontakt";
import OmOs from "./pages/OmOs";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#FAF7F2] font-sans antialiased text-[#2C2523]">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sommerhusrengoering" element={<Sommerhusrengoering />} />
            <Route path="/airbnb-rengoering" element={<AirbnbRengoering />} />
            <Route path="/toemning-af-doedsbo" element={<DoedsboRengoering />} />
            <Route path="/rengoering-af-hus-eller-lejlighed" element={<HusLejlighedRengoering />} />
            <Route path="/hundeklip-og-vask" element={<HundeklipVask />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
